import { Component, OnInit } from '@angular/core';
import { Product } from '../../classes/product';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  public products: Product[] = [];
  public collapse: boolean = true;

  constructor(public productService: ProductService) { 
    
    this.productService.getProducts.subscribe((product) => {
      this.products = product
      this.products.forEach((prod) => {
        if(prod.category === null) {
          this.products = product;
        } else {
          if(prod.category.toLocaleLowerCase() === 'salud' && prod.category !== null) {
            prod.category = 'Bienestar';
          }
        }
      });
    });
    
  }

  ngOnInit(): void {
  }

  get filterbyCategory() {
    const category = [...new Set(this.products.map(product => product.category))];
    return category
  }

  transformCategoryForRoute(category: string): string {
    try {
      return category.toLowerCase().replace(/\s/g, '-');
    } catch (error) {
      return ''
    }
    
  }

}
